import type { User } from 'firebase/auth';

/** True when the user has a real account (not logged out or anonymous). */
export function isSignedInUser(user: User | null | undefined): boolean {
    return !!user && !user.isAnonymous;
}
